<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-returns">
                <template slot="button-content">
                    <i class="cus-page-refresh"></i>
                    Returns
                </template>
                <div>
                    <b-dropdown-item @click="displayList(STATUS.ALL)">
                        <i class="cus-page-refresh"></i>
                        View All Returns
                    </b-dropdown-item>
                    <b-dropdown-item @click="displayList(STATUS.IN_PROGRESS)">
                        <i class="cus-page-refresh"></i>
                        View In Progress
                    </b-dropdown-item>
                    <b-dropdown-item @click="displayList(STATUS.POSTED)">
                        <i class="cus-page-refresh"></i>
                        View Posted
                    </b-dropdown-item>
                </div>

                <li
                    v-if="_hasAccess('billing.return.create')"
                    class="dropdown-divider"
                ></li>

                <b-dropdown-item
                    v-if="_hasAccess('billing.return.create')"
                    @click="openReturnsModal"
                >
                    <i class="cus-add"></i>
                    New Return
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <return-list
                ref="returnList"
                :key="keyview"
                :status="currentStatus"
                @redirect-other-tab="redirectOtherTab"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import ReturnList from "@/components/billing-returns/returns-list";

const ALL = 2;
const IN_PROGRESS = 0;
const POSTED = 1;

export default {
    components: {
        ReturnList
    },
    data() {
        return {
            keyview: 0,
            STATUS: {
                ALL: ALL,
                IN_PROGRESS: IN_PROGRESS,
                POSTED: POSTED
            },
            currentStatus: null
        };
    },
    methods: {
        displayList(status) {
            this.keyview += 1;
            this.currentStatus = status;
        },
        reloadReturns() {
            // Render reloadReturns when the returnList already rendered
            if (this.$refs.returnList) {
                this.displayList(this.currentStatus);
            }
        },
        openReturnsModal() {
            this.$emit("open-new-return");
        },
        redirectOtherTab(tab) {
            this.$emit("redirect-other-tab", tab);
        }
    }
};
</script>
